import React, { useEffect, useState } from 'react'
import { Col, Row, Spinner, Stack } from 'react-bootstrap'
import SVG from 'react-inlinesvg'
import Chart from 'react-apexcharts'
import totalButton from '../../../../_metronic/images/BlueButton.svg'
import AcceptedButton from '../../../../_metronic/images/GreenButton.svg'
import './tpvAcceptanceRate.css'

interface Props {
  data?: any
  reload: boolean
}

export const TpvAcceptanceRate = ({ data, reload }: Props) => {

  const [totalTpvAccepted, setTotalTpvAccepted] = useState<any>()
  const [acceptedRate, setAcceptedRate] = useState<any>()
  const [totalTpv, setTotalTpv] = useState<any>()

  useEffect(() => {
    setTotalTpvAccepted(data?.totalAcceptedTpv)
    setTotalTpv(data?.totalTpv)
    if (data !== undefined) {
      setAcceptedRate(Math.round(data?.acceptanceRate))
    }
  }, [data])

  const optionsAcceptanceRate: Object = {
    chart: {
      fontFamily: 'Inter',
      height: 380,
      type: 'radialBar'
    },
    series: [acceptedRate],
    // minHeight: '100px'
    colors: ['#50CD89'],
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        hollow: {
          margin: 0,
          size: '69%',
        },
        track: {
          show: true,
          startAngle: -90,
          endAngle: 90,
          strokeWidth: '100%',
          background: '#EEF6FF',
        },
        dataLabels: {
          value: {
            fontSize: '42px',
            fontWeight: '700',
            offsetY: -13,
          },
          name: {
            show: false,
          },
        }
      }
    },
    stroke: {
      lineCap: 'round'
    }
  }

  return (
    <>
      <div className='card card-flush card-border mb-5 mb-xl-110 h-auto' style={{ minHeight: '368px', maxHeight: '368px' }}>
        <div className='container mt-8 ms-4 mb-0'>
          <div className='text-dark fw-bolder fs-3'>
            TPV Acceptance Rate
          </div>
        </div>
        {reload ? (
          <div className="text-center align-items-center mt-19">
            <Spinner animation="border" className="text-gray-600 text-center" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
            <Row className='align-items-center mt-10'>
              <Col sm={7} md={7} lg={7} className='' id='chartStyle'>
                <Chart
                  type='radialBar'
                  options={optionsAcceptanceRate}
                  series={[acceptedRate]}
                  height={318}
                  width={330}
                  style={{maxHeight:'222.789'}}
                />
                <div className='d-flex text-muted range' style={{ position: 'absolute', marginTop: '-10%' }}>
                  <div style={{ marginLeft: '100%' }}>0%</div>
                  <div style={{ marginLeft: '368%' }}>100%</div>
                </div>
              </Col>
              <Col sm={5} md={5} lg={5} className='align-self-center'>
                <Stack gap={5} className="ms-5">
                  <div className='d-flex mb-3'>
                    <SVG src={totalButton} className='me-3' />
                    <Stack>
                      <span className='fw-bold fs-2'>{totalTpv}</span>
                      <span className='text-gray-500 fs-7'>Total TPVs</span>
                    </Stack>
                  </div>
                  <div className='d-flex'>
                    <SVG src={AcceptedButton} className='me-3' />
                    <Stack>
                      <span className='fw-bold fs-2'>{totalTpvAccepted}</span>
                      <span className='text-gray-500 fs-7'>Accepted TPVs</span>
                    </Stack>
                  </div>
                </Stack>
              </Col>
            </Row>
        )}
      </div>
    </>
  )
}
